module.exports = __webpack_public_path__ + "img/concurso.2a74820a.png";